module.exports = __webpack_public_path__ + "static/img/top.ed34acb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/top.svg
// module id = 81jr
// module chunks = 0